module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fixed-part"
  }, [_c('x-header', {
    staticClass: "fixed-header",
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n      "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('tab', {
    staticClass: "fixed-tab"
  }, [_c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('行政')
      }
    }
  }, [_vm._v("行政")]), _vm._v(" "), _c('tab-item', {
    attrs: {
      "selected": ""
    },
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('财务')
      }
    }
  }, [_vm._v("财务")]), _vm._v(" "), _c('tab-item', {
    on: {
      "on-item-click": function($event) {
        _vm.changeTab('人力')
      }
    }
  }, [_vm._v("人力")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "list-part"
  }, [_c('div', {
    staticClass: "hideClass",
    class: {
      showClass: _vm.AtdIsActive
    },
    attrs: {
      "id": "attendance"
    }
  }, [_c('div', {
    staticClass: "msg-items"
  }, [_c('div', {
    staticClass: "item-detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'launchPages',
        query: {
          name: 'LeaveApplyPage'
        }
      }
    }
  }, [_c('p', {
    staticClass: "item-detail-type"
  }, [_vm._v("请假申请流程")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hideClass",
    class: {
      showClass: _vm.FinIsActive
    },
    attrs: {
      "id": "finance"
    }
  }, [_c('div', {
    staticClass: "msg-items"
  }, [_c('div', {
    staticClass: "item-detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'launchPages',
        query: {
          name: 'CostExpensePage'
        }
      }
    }
  }, [_c('p', {
    staticClass: "item-detail-type"
  }, [_vm._v("报销申请-费用报销流程")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "msg-items"
  }, [_c('div', {
    staticClass: "item-detail"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'launchPages',
        query: {
          name: 'LoanApplyPage'
        }
      }
    }
  }, [_c('p', {
    staticClass: "item-detail-type"
  }, [_vm._v("借款申请流程")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hideClass",
    class: {
      showClass: _vm.HrIsActive
    },
    attrs: {
      "id": "hr"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-328d86c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Launch.vue
// module id = EC0B
// module chunks = 1